import AuthenticationRepository from "../repository/authentication-repository";
import PermissionService from "./permission-service";

class AuthService
{
    #authRepository;
    #permissionService;
    #authTokenKey;
    #authUserKey;
    #permissionKey;

    constructor() {
        this.#authRepository = new AuthenticationRepository();
        this.#permissionService = new PermissionService();
        this.#authTokenKey = "auth-token";
        this.#authUserKey = "auth-user";
        this.#permissionKey = "permissions";
    }

    async login(username, password) {
        
        try {
            const data = await this.#authRepository.loginWithPassword(username, password);

            if(data.token === null) return false;
            
            sessionStorage.setItem(this.#authTokenKey, data.token);
            sessionStorage.setItem(this.#authUserKey, JSON.stringify(data.user));

            const permissions = await this.#permissionService.findAllForCurrentUser();

            sessionStorage.setItem(this.#permissionKey, JSON.stringify(permissions));
            
            return true;
        } catch (error) {
            console.error(error);
        }
    }

    async logout() {
        
        try {
            await this.#authRepository.logout();

            sessionStorage.clear();

            return true;
        } catch (error) {
            console.error(error);
        }
    }
}

export default AuthService;